import { defineMessages } from 'react-intl';

const messages = defineMessages({
  azure_desc: {
    id: 'ZG7e5H',
    defaultMessage:
      'If you are already an Azure customer, buy through Azure to use your existing credits.',
  },
  buy_now: {
    id: 'lCILNz',
    defaultMessage: 'Buy Now',
  },
  buy_now_azure: {
    id: '3DHzfA',
    defaultMessage: 'Buy now on Azure',
  },
  main_header_1: {
    id: 'E8dH1q',
    defaultMessage: 'With',
  },
  buy_now_ibm: {
    id: 'QYN6ze',
    defaultMessage: 'Buy now on ibm.com',
  },
  buy_now_yours: {
    id: 'uCpdSL',
    defaultMessage: 'Find the purchase option that matches your needs.',
  },
  main_header_2: {
    id: '8ZRIJe',
    defaultMessage:
      ', you have access to flexible purchasing options through different channels. Choose the option that matches your organization’s specific needs.',
  },
  seller_desc: {
    id: 'Z6rSSU',
    defaultMessage: 'If you need additional guidance, please contact sales.',
  },
  sales_desc: {
    id: 'Zsy2ft',
    defaultMessage:
      'Engage with our sales team to obtain answers to your questions, discuss your specific requirement, and receive a personalized quote',
  },
  aws_desc: {
    id: 'jGHHe3',
    defaultMessage:
      'If you are already an AWS customer, buy through AWS to use your existing credits.',
  },
  buy_now_aws: {
    id: '6oJwp/',
    defaultMessage: 'Buy now on AWS',
  },
  quote_form_desc: {
    id: 'loIgDw',
    defaultMessage:
      'Engage with our sales team to obtain answers to your questions, discuss your specific requirement, and receive a personalized quote.',
  },
  ibm_desc: {
    id: 'saypmI',
    defaultMessage:
      'Buy online from IBM in just a few clicks, completing your order with a credit card and get access to your software within minutes.',
  },
  consult_a_seller: {
    id: 'FoZHZ0',
    defaultMessage: 'Consult with a seller',
  },
});

export default messages;
